var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShareIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19.5356C13 18.4311 13.8954 17.5356 15 17.5356H18.5H25.5H29C30.1046 17.5356 31 18.4311 31 19.5356V34.5356C31 35.6402 30.1046 36.5356 29 36.5356H15C13.8954 36.5356 13 35.6402 13 34.5356V19.5356Z",
    stroke: "white",
    strokeWidth: 1.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.53564,
    width: 2,
    height: 18,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6499,
    y: 9.41406,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(-45 20.6499 9.41406)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    rx: 1,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 23.3711 9.41406)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareIos);
export default __webpack_public_path__ + "static/media/ic_share_ios.e1d49159.svg";
export { ForwardRef as ReactComponent };